/*global $*/

import ko from 'knockout';

export function registerComponent() {
  ko.components.register('period-picker', {
    template: { element: 'period-picker-template' },
    viewModel: {
      createViewModel: function (params, componentInfo) {
        return new SearchPeriodPickerViewModel(params, componentInfo);
      },
    },
  });
}

function SearchPeriodPickerViewModel(params, componentInfo) {
  var monthNames = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

  var self = this;
  var $component = $(componentInfo.element);
  $component.click(function (event) {
    event.stopPropagation();
  });

  var period = params.data;
  var close = params.close;
  var content = params.content;
  var now = new Date();
  var minDate = (new Date(now.getFullYear(), now.getMonth(), now.getDate())).getTime();
  var maxDate = (new Date(now.getFullYear() + 1, 12 - 1, 31)).getTime();

  self.initialArrival = null;
  self.initialDuration = null;

  self.arrival = period.Arrival;
  self.duration = period.Duration;
  self.durations = period.Durations;
  self.fieldNameArrival = period.FieldNameArrival;
  self.fieldNameDuration = period.FieldNameDuration;
  self.months = ko.observableArray();
  self.selectedMonth = ko.observable();
  self.selectedArrival = ko.observable();
  self.selectedDuration = ko.observable();
  self.dropdownDuration = ko.observable();
  self.hoverDay = ko.observable();

  self.selectedDeparture = ko.pureComputed(function () {
    return self.selectedArrival() && self.selectedDuration() ? addDays(new Date(self.selectedArrival()), self.selectedDuration()).getTime() : null;
  }, self);

  self.selectedMonth.subscribe(function selectedMonthChanged(newMonth) {
    var nextMonth = addMonths(newMonth, 1);
    var month1 = new Month(newMonth.getFullYear(), newMonth.getMonth() + 1, self);
    var month2 = new Month(nextMonth.getFullYear(), nextMonth.getMonth() + 1, self);
    self.months.splice(0, 2, month1, month2);
  });

  period.Arrival.subscribe(setContent);
  period.Duration.subscribe(setContent);

  var currentMonth = new Date();
  currentMonth.setDate(1);

  self.selectedMonth(currentMonth);

  setContent();

  params.onOpen(function onPeriodPickerOpen() {
    var arrival = parseArrival(period.Arrival());
    var duration = parseDuration(period.Duration());

    self.initialArrival = period.Arrival();
    self.initialDuration = period.Duration();

    var currentMonth = new Date();
    if (arrival) {
      self.selectedArrival(arrival.getTime());
      currentMonth = new Date(arrival.getTime());
    } else {
      self.selectedArrival(null);
    }
    self.selectedDuration(duration);
    self.dropdownDuration(period.Duration());

    currentMonth.setDate(1);
    self.selectedMonth(currentMonth);
  });

  params.onClear(function onPeriodPickerClear() {
    period.Arrival('');
    period.Duration(null);

    $(componentInfo.element).trigger('periodselected');
  });

  self.nextMonth = function () {
    self.selectedMonth(addMonths(self.selectedMonth(), 1));
  };

  self.previousMonth = function () {
    self.selectedMonth(addMonths(self.selectedMonth(), -1));
  };

  self.mouseover = function (e) {
    self.hoverDay(e.time);
  };

  self.mouseout = function () {
    self.hoverDay(null);
  };

  self.select = function (e) {
    if (e.isValid()) {
      if (!self.selectedArrival() || self.selectedDuration()) {
        self.selectedArrival(e.time);
        self.selectedDuration(null);
        self.dropdownDuration('');
      } else {
        if (e.time < self.selectedArrival()) {
          self.selectedDuration(dateDiff(self.selectedArrival(), e.time));
          self.selectedArrival(e.time);
        } else {
          self.selectedDuration(dateDiff(e.time, self.selectedArrival()));
        }

        var arrival = new Date(self.selectedArrival());

        period.Arrival(arrival.getDate() + '-' + (arrival.getMonth() + 1) + '-' + arrival.getFullYear());
        period.Duration(self.selectedDuration());
        self.dropdownDuration(self.selectedDuration().toString());
        $(componentInfo.element).trigger('periodselected');
      }
    }
  };

  self.apply = function () {
    close();
  };

  self.cancel = function () {
    if (period.Arrival() != this.initialArrival || period.Duration() != this.initialDuration) {
      period.Arrival(this.initialArrival);
      period.Duration(this.initialDuration);

      $(componentInfo.element).trigger('periodselected');
    }
    close();
  };

  self.isValid = ko.pureComputed(function () {
    return period.Durations ? self.selectedDuration() : self.selectedArrival() && self.selectedDuration();
  }, self);

  self.hasDurations = ko.pureComputed(function () {
    return !!period.Durations;
  }, self);

  self.dropdownDuration.subscribe(function dropdownDurationChanged(newDuration) {
    self.selectedDuration(parseDuration(newDuration));
    period.Duration(newDuration);

    $(componentInfo.element).trigger('periodselected');
  });

  function Month(year, month, calendar) {
    this.id = '' + year + month;
    this.year = year;
    this.month = month;
    this.name = monthNames[month - 1] + ' ' + year;
    this.weeks = [];

    var startDate = new Date(year, month - 1, 1);
    startDate = addDays(startDate, -((startDate.getDay() - 1 + 7) % 7));

    this.startDate = startDate;

    for (var i = 0; i < 6; i++) {
      this.weeks[i] = new Week(month, startDate, calendar);
      startDate = addDays(startDate, 7);
    }
  }

  function Week(month, startDate, calendar) {
    this.startDate = startDate;
    this.days = [];

    for (var i = 0; i < 7; i++) {
      this.days[i] = new Day(month, startDate, calendar);
      startDate = addDays(startDate, 1);
    }
  }

  function Day(month, date, calendar) {
    this.time = date.getTime();
    this.number = date.getDate();

    this.isInMonth = date.getMonth() === (month - 1);

    this.isHovered = ko.pureComputed(function () {
      return this.isInMonth && calendar.hoverDay() === this.time;
    }, this);

    this.isSelected = ko.pureComputed(function () {
      return this.isInMonth && ((calendar.selectedArrival() === this.time) || (calendar.selectedDeparture() === this.time));
    }, this);

    this.isInRange = ko.pureComputed(function () {
      return this.isInMonth && calendar.selectedArrival() && calendar.selectedDeparture() && calendar.selectedArrival() <= this.time && calendar.selectedDeparture() >= this.time;
    }, this);

    this.isInHoverRange = ko.pureComputed(function () {
      return this.isInMonth && calendar.selectedArrival() && !calendar.selectedDeparture() && calendar.hoverDay() && ((calendar.selectedArrival() <= this.time && calendar.hoverDay() >= this.time) || (calendar.hoverDay() <= this.time && calendar.selectedArrival() >= this.time));
    }, this);

    this.isOutOfRange = ko.pureComputed(function () {
      return this.isInMonth && !(minDate <= this.time && maxDate >= this.time);
    }, this);

    this.isValid = ko.pureComputed(function () {
      var duration = Math.abs(dateDiff(this.time, calendar.selectedArrival()));
      return !this.isOutOfRange() && (!calendar.selectedArrival() || calendar.selectedDeparture() || (duration > 1.5 && duration < 35.5 && (!self.durations || self.durations.filter(d => d.Value == duration)[0])));
    }, this);
  }

  function addDays(date, days) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);
  }

  function addMonths(date, months) {
    return new Date(date.getFullYear(), date.getMonth() + months, date.getDate());
  }

  function setContent() {
    var arrival = parseArrival(period.Arrival());
    var duration = parseDuration(period.Duration());
    if (arrival && duration) {
      var departure = addDays(arrival, duration);
      content(arrival.getDate() + '.' + (arrival.getMonth() + 1) + '.' + arrival.getFullYear() + '-' + departure.getDate() + '.' + (departure.getMonth() + 1) + '.' + departure.getFullYear());
    } else if (duration && period.Durations) {
      var option = period.Durations.filter(p => p.Value == period.Duration())[0];
      if (option) {
        content(option.Text);
      } else {
        content('');
      }
    } else {
      content('');
    }
  }

  function parseArrival(arrival) {
    var parts = arrival.split(/[\s\-./]+/);
    if (parts.length !== 3) {
      return null;
    } else {
      return new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
    }
  }

  function parseDuration(duration) {
    return parseInt(duration);
  }

  function dateDiff(date1, date2) {
    var diff = date1 - date2;
    return Math.round(diff / 86400000);
  }
}
